import { atom } from "jotai";

export const alertData = atom(false);
